<div style="margin-top:10%"></div>
<div class="container">
  <div class="cManikBooking">
    <div id="ManikBookingResourceType" class="form-group">
      <label for="ddResourceType">I Want To Book</label>
      <select id="ddResourceType" class="form-control"></select>
    </div>
    <div id="ManikBookingDate">
      <label for="dtBookDate">Date</label>
      <input id="dtBookDate" class="cManikDatePic" type="date" name="bday">
    </div>
    <div id="ManikBookingResourceShift" class="form-group">
      <label for="ddShift">Shift</label>
      <select class="form-control" id="ddShift"></select>
    </div>
    <div id="ManikBookingResourceSlot" class="form-group">
      <label for="ddSlot">Slot</label>
      <select class="form-control" id="ddSlot"></select>
    </div>
    <div id="ManikBookingResource" class="form-group">
      <label for="ddResource">Resource</label>
      <select class="form-control" id="ddResource"></select>
    </div>
    <div id="ManikBookInfo1" class="cManikBookingMinWidth form-group">
      <label for="txtBookInfo1">Pax(adult)</label>
      <input class="form-control input-lg" id="txtBookInfo1" type="text" placeholder="Pax(adult)">
    </div>
    <div id="ManikBookInfo2" class="cManikBookingMinWidth form-group">
      <label for="txtBookInfo2">Pax(children)</label>
      <input class="form-control input-lg" id="txtBookInfo2" type="text" placeholder="Pax(children)">
    </div>
    <div id="ManikBook" class="cManikBookingButton">
      <button type="button" id="btnBook" class="btn btn-warning">Book</button>
    </div>
  </div>
</div>
